import React from 'react';
import PropTypes from 'prop-types';
import RIEBase from 'components/core/editable/RIEBase';

/**
 * Modified from https://github.com/kaivi/riek, v1.1.0
 *
 * RIE components need to implement the following methods:
 *
 * 1)
 */
export default class Entity extends RIEBase {
    static propTypes = {
        children: PropTypes.string,
        bold: PropTypes.bool
    };

    static defaultProps = {
        bold: false
    };

    constructor(props) {
        super(props);

        this.state = {
        };
    }

    //cannont override parent class's method since it is inline and calls to 'super'
    //from within fail.
    makeReadOnlyClassString = () => {
        const classNames = [];
        classNames.push(this.makeClassString());
        classNames.push('read-only');
        return classNames.join(' ');
    };


    renderReadComponent = () => {
        const value = this.getNewValue();
        return (
            <span
                tabIndex="0"
                className={this.makeReadOnlyClassString()}
                {...this.props.defaultProps}
            >
                {this.props.bold ? <strong>{value}</strong> : value }
                {this.props.children ? <span className="sub-text">{this.props.children}</span> : ''}
            </span>
        );
    };


}



// WEBPACK FOOTER //
// ./src/components/core/Entity.js